import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import theme from "../theme/theme";
import { polyfillsForPrintService } from "./polyfills";
import printJS from "print-js";
import { fetch } from "whatwg-fetch";

polyfillsForPrintService();

const printableTypes = [
  {
    contentType: "application/pdf",
    printType: "pdf"
  },
  {
    contentType: "text/html",
    printType: "raw-html"
  },
  {
    contentType: "image/png",
    printType: "image"
  },
  {
    contentType: "image/jpeg",
    printType: "image"
  },
  {
    contentType: "image/gif",
    printType: "image"
  }
];

export function isPrintable(type) {
  return (
    printableTypes
      .map(function(type) {
        return type.contentType;
      })
      .indexOf(type) > -1
  );
}

function getPrintType(type) {
  return printableTypes.find(obj => obj.contentType === type).printType;
}

function printHtml(link, contentType, params) {
  return fetch(link)
    .then(response => {
      return response.text();
    })
    .then(function(response) {
      return runPrint(response, contentType, params);
    })
    .catch(function(error) {
      console.log("request failed", error);
    });
}

export function printContent(contentLink, contentType, params = {}) {
  if (contentType === "text/html") {
    printHtml(contentLink, contentType, params);
  } else {
    runPrint(contentLink, contentType, params);
  }
}

function runPrint(content, contentType, params) {
  printJS({
    printable: content,
    type: getPrintType(contentType),
    onBrowserIncompatible: function() {
      alert("Browser not compatible!");
    },
    ...params
  });
}

export function openPrintDocument(
  url = "",
  mode = "",
  options_string,
  content = "Inner HTML"
) {
  if (options_string === null) {
    options_string = "width=980,height=780";
  }
  let win = window.open(url, "name", options_string);
  win.document.body.innerHTML =
    '<div id="print_container" style="pointer-events: none"></div>';
  let container = win.document.getElementById("print_container");
  ReactDOM.render(wrapContent(content), container);
  copyStyles(window.document, win.document);
  if (win.attachEvent) {
    win.attachEvent("onload", onWinLoad(win));
  } else if (win.addEventListener) {
    win.addEventListener("load", onWinLoad(win), false);
  } else {
    win.addEventListener("load", onWinLoad(win), false);
  }
}

function onWinLoad(win) {
  win.document.close();
  win.focus();
  win.print();
  setTimeout(win.close(), 0);
}

function copyStyles(sourceDoc, targetDoc) {
  let targetHead = targetDoc.getElementsByTagName("head")[0];
  Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
    if (styleSheet.href === null) {
      if (styleSheet.cssRules) {
        const newStyleEl = targetDoc.createElement("style");
        targetHead.appendChild(newStyleEl);

        Array.from(styleSheet.cssRules).forEach(cssRule => {
          if (newStyleEl.styleSheet) {
            newStyleEl.styleSheet.cssText.appendChild = cssRule;
          } else {
            newStyleEl.appendChild(targetDoc.createTextNode(cssRule.cssText));
          }
        });
      }
    }
  });
}

function wrapContent(content) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{content}</ThemeProvider>
    </StyledEngineProvider>
  );
}
